module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.visible,
      "width": "440px",
      "append-to-body": "",
      "show-close": false,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "custom-class": ("nd-modal nd-modal--" + _vm.tone)
    }
  }, [_c('div', {
    staticClass: "nd-modal__body"
  }, [_c('div', {
    staticClass: "nd-modal__badge"
  }, [_c('span', {
    class: ['nd-modal__ring', {
      'nd-modal__ring--spin': _vm.loading
    }]
  }), _vm._v(" "), _c('i', {
    class: ['fa', _vm.icon, 'nd-modal__icon', {
      'nd-modal__icon--pulse': _vm.loading
    }]
  })]), _vm._v(" "), _c('h4', {
    staticClass: "nd-modal__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "nd-modal__text"
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), (_vm.hint) ? _c('p', {
    staticClass: "nd-modal__hint"
  }, [_c('i', {
    staticClass: "fa fa-lightbulb-o"
  }), _vm._v(" " + _vm._s(_vm.hint))]) : _vm._e()]), _vm._v(" "), (_vm.loading) ? _c('el-progress', {
    staticClass: "nd-modal__progress",
    attrs: {
      "percentage": _vm.progress,
      "stroke-width": 6,
      "show-text": false,
      "color": "rgb(104, 48, 144)"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loading && _vm.progressText) ? _c('p', {
    staticClass: "nd-modal__progress-text"
  }, [_vm._v(_vm._s(_vm.progressText))]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "nd-modal__footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.showRefresh) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-refresh",
      "loading": _vm.refreshing
    },
    on: {
      "click": function($event) {
        return _vm.$emit('refresh')
      }
    }
  }, [_vm._v("\n      Refresh\n    ")]) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56d2a9f9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/segmentation/common/NoDataModal.vue
// module id = 3289
// module chunks = 3